import AppIcon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';
import { formatNumber } from '../../../utils/formatNumber';

const PhotographerRankings = ({ photographers }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm mb-6 md:mb-8">
      <div className="mb-4">
        <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
          تصنيف أداء المصورين
        </h3>
        <p className="text-sm text-muted-foreground">
          أفضل المصورين حسب الأرباح والحجوزات والتقييمات
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                الترتيب
              </th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                المصور
              </th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                الحجوزات
              </th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                معدل الإكمال
              </th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                الأرباح
              </th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-muted-foreground">
                التقييم
              </th>
            </tr>
          </thead>
          <tbody>
            {photographers?.slice(0, 10)?.map((photographer, index) => (
              <tr
                key={photographer?.id}
                className="border-b border-border hover:bg-muted/50 transition-smooth"
              >
                <td className="py-3 px-2">
                  <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm">
                    {index + 1}
                  </div>
                </td>
                <td className="py-3 px-2">
                  <div className="flex items-center gap-3">
                    <AppImage
                      src={photographer?.avatar || 'https://img.rocket.new/generatedImages/rocket_gen_img_120a8b556-1763295072140.png'}
                      alt={`صورة ${photographer?.name}`}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <span className="font-medium text-foreground">
                      {photographer?.name}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-2">
                  <div className="text-sm">
                    <div className="font-semibold text-foreground">
                      {formatNumber(photographer?.totalBookings)}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {formatNumber(photographer?.completedBookings)} مكتملة
                    </div>
                  </div>
                </td>
                <td className="py-3 px-2">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
                      <div
                        className="h-full bg-success rounded-full transition-all"
                        style={{ width: `${photographer?.completionRate}%` }}
                      />
                    </div>
                    <span className="text-sm font-medium text-foreground">
                      {photographer?.completionRate}%
                    </span>
                  </div>
                </td>
                <td className="py-3 px-2">
                  <div className="font-semibold text-success">
                    {formatNumber(photographer?.earnings)} ريال
                  </div>
                </td>
                <td className="py-3 px-2">
                  <div className="flex items-center gap-1">
                    <AppIcon name="Star" size={16} color="var(--color-warning)" />
                    <span className="font-medium text-foreground">
                      {photographer?.avgRating}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      ({photographer?.reviewCount})
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {photographers?.length === 0 && (
        <div className="text-center py-8">
          <AppIcon name="Users" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
          <p className="text-muted-foreground">لا توجد بيانات متاحة</p>
        </div>
      )}
    </div>
  );
};

export default PhotographerRankings;